const progressDescription = ({ name, getDescription, fieldsValue }) => {
  if (!getDescription) return null;
  switch (name) {
    default:
      return getDescription(fieldsValue);
  }
};

export default progressDescription;
